import styled, { css } from "styled-components";

const Text = styled.p`
  ${({
    theme,
    color,
    fontSize,
    fontFamily,
    fontWeight,
    textAlign,
    onHoverColor,
    marginTop,
    marginLeft,
    marginRight,
    marginBottom,
    width,
    letterSpacing,
    oneline,
  }) => {
    return css`
      display: inline-block;
      width: ${width || "auto"};
      color: ${color || `#fff`};
      font-size: ${fontSize || theme.fontSize.small};
      font-weight: ${fontWeight || 500};
      text-align: ${textAlign || "left"};
      ${fontFamily
        ? css`
            font-family: ${fontFamily};
          `
        : ``}
      ${oneline
        ? css`
            white-space: nowrap;
            overflow: hidden;
          `
        : css`
            white-space: wrap;
            word-wrap: break-word;
          `}
      box-sizing: border-box;
      margin: 0;
      margin-top: ${marginTop || 0};
      margin-left: ${marginLeft || 0};
      margin-right: ${marginRight || 0};
      margin-bottom: ${marginBottom || 0};
      letter-spacing: ${letterSpacing || ""};
      &:hover {
        color: ${onHoverColor || color || "#fff"};
      }
    `;
  }}
`;

export { Text };
